import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {PermissionsService} from "../../services/permissions/permissions.service";
import {SharedService} from "../shared/shared.service";

@Injectable({
    providedIn: 'root'
})
export class OrgCreationGuard implements CanActivate {

    constructor(
        private featureFlagService: PermissionsService,
        private router: Router,
        private sharedService: SharedService
    ) {
    }

    canActivate(): boolean {
        const languageData = this.sharedService.getLanguageData();
        if (languageData === true) {
            this.sharedService.setLanguageData(false);
            return true;
        }
        let isComingFromUserDetails = false;
        const navigation = localStorage.getItem('previousUrl');
        if (navigation) {
            isComingFromUserDetails = navigation.includes('/user-details') || navigation.includes('/user-verify') || navigation.includes('/user-logged-in');
        } else {
            window.location.href = '/login';
            return false;
        }
        const hasValidAccess = isComingFromUserDetails;

        if (!hasValidAccess) {
            window.location.href = '/login';
            return false;
        }
        return true;
    }
}
